<template>
  <div class="report">
    <v-row>
      <v-col class="document-title">
        <h1 v-if="params.user && params.user.id">Promet prodajalca</h1>
        <h1 v-else>Promet prodajalcev</h1>
      </v-col>
    </v-row>
    <ReportPrintAllHeader :params="params" />

    <v-row class="table-header">
      <v-col>
        Ime prodajalca
      </v-col>
      <v-col>
        Promet skupaj
      </v-col>
    </v-row>
    <v-row class="table-header">
      <v-col cols="5" offset="1">
        Način plačila
      </v-col>
      <v-col cols="5" offset="1">
        Znesek
      </v-col>
    </v-row>

    <!-- A{{ data[0] }} -->

    <div v-for="item in data" :key="item.name">
      <v-row>
        <v-col>
          {{item.user}}
        </v-col>
        <v-col :inner-html.prop="item.total | price(2)">
        </v-col>
      </v-row>
      <div class="row" v-for="paymentMethod of item.paymentMethods" :key="paymentMethod.name">
        <v-col cols="5" offset="1">
          {{paymentMethod.name}}
        </v-col>
        <v-col cols="5" offset="1" :inner-html.prop="paymentMethod.sum | price(2)">
        </v-col>
      </div>
    </div>

    <v-row>
      <v-col>
        <v-row class="table-footer">
          <v-col>Skupaj:</v-col>
          <v-col :inner-html.prop="total | price(2)"></v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ReportPrintAllHeader from './ReportPrintAllHeader'

export default {
  components: {
    ReportPrintAllHeader
  },
  props: {
    data: {
      required: true,
      type: Array
    },
    params: {
      required: true,
      type: Object
    }
  },
  computed: {
    total () {
      return this.data.reduce((total, item) => total + item.total, 0)
    }
  }
}
</script>

<style lang="scss">
.theme--light.v-application {
  background-color: white;
}
</style>

<style lang="scss" scoped>
html, body {
  font-size: 70%;
}
.report {
  padding: 30px 20px;
}
.document-title {
  margin-bottom: 30px;
  text-align: center;
}
.table-title {
  background-color: #eaeaea;
  font-weight: bold;
}
.table-header,
.table-footer {
  border: 1px solid black;
  background-color: #e5e5e5;
  font-weight: bold;
  font-size: 115%;
}
.devider {
  padding-top: 0px;
  margin-top: 0px;
  margin-bottom: 10px;
  border-top: 1px solid black;
}
.row.condenced {
  .col {
    padding: 5px;
  }
}
</style>
